<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import merchApiDrive from "@/services/http/api-drive/magasin/merch";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";
const { layout } = useContextStore();
const { trackPage } = useTrackingPage();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.prospectus);
});

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/infos-et-services/prospectus/${layout}.vue`
    ]
  );
});

const conf = useRuntimeConfig();
const { id: magasinId } = useMagasinStore();
let prospectus = [];

const { data } = await useAsyncData((app) =>
  cacheResponse(
    app.$apiServerCacheRedis,
    `${cacheKeys.prospectusPrefix}${magasinId}`,
    app.$apiDrive.use(merchApiDrive).prospectus(magasinId),
    useRuntimeConfig().public.API_DRIVE_CACHE_MAGASIN
  )
);

if (data.value) {
  prospectus = data.value.data;
}

useHead(() => {
  return {
    title: "Prospectus cora- Faites des économies en consultant nos prospectus",
    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "Faites des économies en consultant les prospectus cora et restez informés des bonnes affaires du moment également sur cora.fr"
      }
    ],
    link: [{ rel: "canonical", href: "/prospectus" }]
  };
});
</script>

<template>
  <component
    :is="component"
    :prospectus="prospectus"
  />
</template>
